var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog"},[(_vm.$slots.default)?_c('div',{class:{
			dialog__body: true,
			'dialog__body--with-actions': _vm.$slots.actions
		}},[_vm._t("default")],2):_vm._e(),(_vm.$slots.actions)?_c('div',{staticClass:"dialog__actions"},[_vm._t("actions")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }